export const REFINERY_ENROLL_PATH = '/refinery/enroll'
export const DEFAULT_POST_LOGIN_PATH = '/dashboard'

export function needsRefineryEnrollment(company, user) {
  // company/user are null until selected (e.g. mid-login, before the profile loads)
  if (user?.isAdmin) return false
  return Boolean(company?.refineryCustomer) && !company?.refineryAgreementAcceptedAt
}

export function postLoginPath(company, user) {
  return needsRefineryEnrollment(company, user) ? REFINERY_ENROLL_PATH : DEFAULT_POST_LOGIN_PATH
}

export function isRefineNavItem(item) {
  return item.meta.title === 'refine'
}

export function refineNavColor(item, company, user) {
  return isRefineNavItem(item) && needsRefineryEnrollment(company, user) ? 'secondary' : 'primary'
}

export function refineNavPulseClass(item, company, user) {
  return isRefineNavItem(item) && needsRefineryEnrollment(company, user) ? 'refine-now-pulse' : ''
}
